import {
  AbstractControl,
  UntypedFormArray,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';

export const atLeastOneArrayItemValidator = (...fields :string[]) :ValidatorFn => {
  return (control :AbstractControl) :{ [key :string] :any } | null => {
    const hasAtLeastOne = fields.some((field) => {
      const arrayControl = control.get(field) as UntypedFormArray;

      return arrayControl && arrayControl.controls.length > 0;
    });

    return hasAtLeastOne ? null : { atLeastOneArrayItemRequired: true };
  };
};

export function emptyStringValidator() :ValidatorFn {
  return (control :AbstractControl) :ValidationErrors | null => {
    return control.value && control.value.trim() === ''
      ? { emptyString: true }
      : null;
  };
}

export function requiredNonZeroValidator() :ValidatorFn {
  return (control :AbstractControl) :ValidationErrors | null => {
    const value = control.value;
    // Check if the value is null, undefined, NaN, empty string, or zero
    if (
      value === null ||
      value === undefined ||
      value === '' ||
      Number(value) === 0
    ) {
      return { requiredNonZero: true };
    }

    return null;
  };
}

export function emailValidator() :ValidatorFn {
  return (control :AbstractControl) :{ [key :string] :boolean } | null => {
    if (!control.value) {
      return null;
    }

    const isValid =
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        control.value,
      );

    return isValid ? null : { email: true };
  };
}
